































































import  { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/stores';
import RouteList from '@/components/RouteList.vue';
import * as util from "comunet-jobs-and-technician-repository-shared/util";

@Component({
  components: {
    RouteList
  }
})
export default class App extends Vue {
  private showBuildSignature: boolean = process.env.VUE_APP_SHOW_BUILD_SIGNATURE;
  private buildSignature: string = process.env.VUE_APP_BUILD_SIGNATURE;

  private userMenu: boolean = false;

  get drawerOpen(){
    return vxm.navigation.drawerOpen;
  }

  get title(){
    return vxm.user.displayName;
  }

  get displayName(){
    return vxm.user.displayName;
  }

  get isLoggedIn(){
    return vxm.auth.isLoggedIn && vxm.user.user;
  }

  get navigationLoading(){
    return vxm.navigation.loading;
  }

  setDrawerOpen(drawerOpen: boolean){
    vxm.navigation.setDrawerOpen(drawerOpen);
  }

  closeDrawer(){
    this.setDrawerOpen(false);
  }

  toggleDrawer(){
    this.setDrawerOpen(!this.drawerOpen);
  }

  get snackbarVisible(){
    return vxm.navigation.snackbarVisible;
  }

  get snackbarMessage(){
    return vxm.navigation.snackbarMessage;
  }

  get snackbarColor(){
    return vxm.navigation.snackbarColor;
  }

  get officePhoneHref() {
    if(vxm.user.user == null || vxm.user.user.address == null || vxm.user.user.address.stateID == null){
      return null;
    }

    let phoneNumber = "";

    let stateID = vxm.user.user!.address.stateID.toString();

    if (stateID == util.States.SA) {
      phoneNumber = "1800 640 164";
    }
    else if (stateID == util.States.WA) {
      phoneNumber = "1800 640 164";
    }
    else if (stateID == util.States.NT) {
      phoneNumber = "1800 640 164";
    }
    else if (stateID == util.States.QLD) {
      phoneNumber = "1800 640 164";
    }
    else if (stateID == util.States.NSW) {
      phoneNumber = "1800 640 164";
    }
    else if (stateID == util.States.VIC) {
      phoneNumber = "1800 640 164";
    }
    else if (stateID == util.States.TAS) {
      phoneNumber = "1800 640 164";
    }
    else if (stateID == util.States.ACT) {
      phoneNumber = "1800 640 164";
    }

    if (phoneNumber) {
      return "tel:" + phoneNumber;
    }

    return "";
  }

  logout(){
    this.userMenu = false;
    this.$router.push({ name: "logout" });
  }

  created(){
    if(this.buildSignature){
      // eslint-disable-next-line
      console.log("Build Signature: " + this.buildSignature);
    }
  }
}
